<template>
  <div class="bzscbb-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="getData" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name"  :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="包装日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button @click="getData" icon="el-icon-search">搜索</el-button>
              <el-button icon="el-icon-printer" @click="print">打印报表</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <table class="tcf-bb-table">
              <thead>
                <tr>
                  <th colspan="4">已完成 总金额：{{completionAmount}}</th>
                  <th colspan="5">在制品 总金额：{{workAmount}}</th>
                  <th colspan="7">欠尾数 总金额：{{woedAmount}}</th>
                </tr>
                <tr>
                  <th>序号</th>
                  <th>生产单号</th>
                  <th>金额</th>
                  <th>完成日期</th>
                  <th>序号</th>
                  <th>生产单号</th>
                  <th>金额</th>
                  <th>件数</th>
                  <th>已完成比例</th>
                  <th>序号</th>
                  <th>生产单号</th>
                  <th>金额</th>
                  <th>件数</th>
                  <th>未完成比例</th>
                  <th>未包</th>
                  <th>包装人</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="t in tableData">
                  <td>{{t.xuhao}}</td>
                  <td>{{t.produnum}}</td>
                  <td>{{t.amount}}</td>
                  <td>{{t.finshtime}}</td>
                  <td>{{t.xuhao2}}</td>
                  <td>{{t.produnum2}}</td>
                  <td>{{t.amount2}}</td>
                  <td>{{t.cases2}}</td>
                  <td>{{t.process2}}</td>
                  <td>{{t.xuhao3}}</td>
                  <td>{{t.produnum3}}</td>
                  <td>{{t.amount3}}</td>
                  <td>{{t.cases3}}</td>
                  <td>{{t.unfinished3}}</td>
                  <td>{{t.wbs}}</td>
                  <td>{{t.packname3}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getErpPackRepor, getFactoryList, getGroupInfoByUser } from '@/api/erp'
import { getLodop } from '@/common/Lodop/LodopFuncs'

export default {
  name: 'bzscbb',
  computed: {
    user: getUser
  },
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      searchForm: {
        time: [],
        factory: null
      },
      data: '',
      tableData: [],
      completionAmount: '',
      workAmount: '',
      woedAmount: '',
      factoryList: [],
      group: {
        dBrand: 1
      }
    }
  },
  created() {
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getFactoryList().then(response => {
      this.factoryList = response.data
    })
    const myDate = new Date()
    const year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day
    this.searchForm.time.push(year + '-' + month + '-01')
    this.searchForm.time.push(year + '-' + month + '-' + day)
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.completionAmount = 0
      this.workAmount = 0
      this.woedAmount = 0
      let starttime = ''
      let endtime = ''
      if (this.searchForm.time.length > 0) {
        starttime = this.searchForm.time[0]
        endtime = this.searchForm.time[1]
      }
      const data = {
        starttime: starttime,
        endtime: endtime,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        factory: this.searchForm.factory
      }
      getErpPackRepor(data).then(response => {
        const lst = response.data
        let html = ''
        this.tableData = lst
        for (let i = 0; i < lst.length; i++) {
          html += '<tr style="text-align:center;border-collapse:collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">' +
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">' + lst[i].xuhao + '</td>' +
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">' + lst[i].produnum + '</td>' +
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">' + lst[i].amount + '</td>' +
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">' + lst[i].finshtime+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">' + lst[i].xuhao2+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">' + lst[i].produnum2+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">' + lst[i].amount2+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">' + lst[i].cases2+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].process2+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].xuhao3+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].produnum3+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].amount3+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].cases3+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].unfinished3+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].wbs+'</td>'+
            '<td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">'+lst[i].packname3+'</td>'+
            '</tr>'
          if (lst[i].amount !== '' && lst[i].amount !== null && lst[i].amount !== undefined) {
            this.completionAmount = lst[i].amount
          }
          if (lst[i].amount2 !== null && lst[i].amount2 !== '' && lst[i].amount2 !== undefined) {
            this.workAmount = lst[i].amount2
          }
          if (lst[i].amount3 !== null && lst[i].amount3 !== '' && lst[i].amount3 !== undefined) {
            this.woedAmount = lst[i].amount3
          }
        }
        html += '</tbody> <tfoot>\n' +
          '                  <tr>\n' +
          '                    <TD colspan="16"  style="text-align: right;font-size:12pt;padding-top: 3mm;">\n' +
          '                      第&nbsp;<span tdata="pageNO" format="#">#</span>&nbsp;/&nbsp;<span tdata="pageCount" format="#">#</span>&nbsp;页\n' +
          '                    </TD>\n' +
          '                  </tr>\n' +
          '                  </tfoot>\n' +
          '                </table>'
        html = '<table style="border-collapse: collapse;page-break-before:always;font-family:宋体;width: 100%;">\n' +
          '                  <thead>\n' +
          '                  <tr>\n' +
          '                    <td colspan="15" style="font-size:30pt;text-align:center;line-height:60px;font-weight: bold;" id="title" >\n' +
          '                      <span>包装车间生产报表</span>\n' +
          '                    </td>\n' +
          '                  </tr>\n' +
          '                  <tr style="text-align:center;border-collapse:collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">\n' +
          '                    <td colspan="4" style="text-align:center;border-collapse: collapse;border:1px solid black;">已完成 总金额：'+ this.completionAmount +'</td>\n' +
          '                    <td colspan="5" style="text-align:center;border-collapse: collapse;border:1px solid black;">在制品 总金额：'+ this.workAmount +'</td>\n' +
          '                    <td colspan="7" style="text-align:center;border-collapse: collapse;border:1px solid black;">欠尾数 总金额：'+ this.woedAmount +'</td>\n' +
          '                  </tr>\n' +
          '                  <tr style="text-align:center;border-collapse:collapse;border:1px solid black;height:8mm;font-size:16pt;word-break: keep-all;white-space:nowrap;">\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">序<br>号</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">生产单号</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">金额</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">完成<br>日期</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">序<br>号</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">生产单号</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">金额</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">件数</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">已完成<br>比例</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 2mm;">序<br>号</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">生产单号</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">金额</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">件数</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">未完成<br>比例</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">未包</td>\n' +
          '                    <td style="text-align:center;border-collapse: collapse;border:1px solid black;padding:1mm 0;">包装人</td>\n' +
          '                  </tr>\n' +
          '                  </thead>\n' +
          '                  <tbody>' + html
        this.data = html
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    print() {
      const LODOP = getLodop()
      if (LODOP !== null && LODOP !== undefined) {
        LODOP.PRINT_INIT('包装生产报表打印')
        LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
        LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
        LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', this.data)
        LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
        LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
        LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
        LODOP.NewPageA()
        LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
        LODOP.PREVIEW()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tcf-bb-table{
  width: 100%;
  background-color: #fff;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 13px;
  text-align: center;
  margin-top: 20px;
  thead{
    color: #909399;
    font-weight: 500;
    tr{
      th{
        border: 1px solid #EBEEF5;
        background: #f6f8fa;
        color: #303133;
        padding: 12px 0;
      }
    }
  }
  tbody{
    tr{
      td{
        border: 1px solid #EBEEF5;
        color: #303133;
        padding: 12px 0;
      }
      &:hover{
        background: #f3f6f9;
      }
    }
  }
}
</style>

